import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import styled from '@emotion/styled';
import Truncate from 'react-truncate';
import moment from 'moment-timezone';

import {
  getSavedTimezone,
  timezoneCode,
} from 'ui_system/utilities/timezoneUtils';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import PropsMixin from 'views/shared/tours/page/glance/mixin';
import ModalActionCreator from 'action_creators/modal';
import {
  Grid,
  Theme,
  CircleAvatar,
  Button,
  TruncatedGradient,
} from 'views/anyguide/messages/styles';
import Addons from './addons';
import CancellationPolicy from './cancellation_policy';

const ResourceGrid = styled(Grid)`
  margin-top: 40px;
  @media (max-width: ${Theme.mobile.phoneMaxWidth}px) {
    margin-top: 30px;
    grid-template-columns: '100%';
  }
`;

const ResourceModal = styled(Grid)`
  padding: 40px 80px 70px;
  /* max-height: ${document.body.clientHeight -
  100 -
  parseInt(document.body.clientHeight / 10)}px; */
  overflow: scroll;
  text-align: center;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    padding: 10px 20px 10px;
  }
`;

const ResourceAvatar = styled(CircleAvatar)`
  top: 0px;
  @media (max-width: ${Theme.mobile.phoneMaxWidth}px) {
    margin: 0px auto 30px;
  }
`;

const ResourceModalAvatar = styled(CircleAvatar)`
  margin: 20px auto;
  margin-bottom: 0px;
  top: -20px;
`;

const ResourceDetails = styled('div')`
  border-top: 1px solid #e6e6e6;
  margin-top: 40px;
`;

const ResourceName = styled('div')`
  font-size: 18px;
  margin-bottom: 15px;
  @media (max-width: ${Theme.mobile.phoneMaxWidth}px) {
    text-align: center;
  }
`;

const ResourceModalName = styled(ResourceName)`
  font-size: 21px;
  font-weight: 600;
`;

const ResourceBio = styled(Truncate)`
  position: relative;
  font-size: 14px;
`;

const ResourceModalBio = styled('div')`
  border-top: 1px solid #e6e6e6;
  padding-top: 20px;
  margin-top: 0px;
  font-size: 14px;
  text-align: left;
`;

const MoreButton = styled(Button)`
  margin: 30px auto;
  display: block;
  @media (max-width: ${Theme.mobile.phoneMaxWidth}px) {
    padding: 10px 0px;
  }
`;

const ResourceInfo = styled('div')`
  position: relative;
`;

const unitNounMessages = defineMessages({
  Adult: { defaultMessage: 'Adult' },
  Adults: { defaultMessage: 'Adults' },
  Child: { defaultMessage: 'Child' },
  Children: { defaultMessage: 'Children' },
  Guest: { defaultMessage: 'Guest' },
  guests: { defaultMessage: 'guests' },
  Minor: { defaultMessage: 'Minor' },
  person: { defaultMessage: 'person' },
  Senior: { defaultMessage: 'Senior' },
  Seniors: { defaultMessage: 'Seniors' },
  Tickets: { defaultMessage: 'Tickets' },
});

const languageMessages = defineMessages({
  English: {
    defaultMessage: 'English',
  },
  French: {
    defaultMessage: 'French',
  },
  Italian: {
    defaultMessage: 'Italian',
  },
  Spanish: {
    defaultMessage: 'Spanish',
  },
  Swedish: {
    defaultMessage: 'Swedish',
  },
});

const durationMessages = defineMessages({
  hour: {
    defaultMessage: '{num} {num, plural, one {Hour} other {Hours}}',
    description: 'Duration display for hours, e.g. "2 Hours"',
  },
  minute: {
    defaultMessage: '{num} {num, plural, one {Minute} other {Minutes}}',
    description: 'Duration display for minutes, e.g. "30 Minutes"',
  },
  day: {
    defaultMessage: '{num} {num, plural, one {Day} other {Days}}',
    description: 'Duration display for days, e.g. "3 Days"',
  },
  week: {
    defaultMessage: '{num} {num, plural, one {Week} other {Weeks}}',
    description: 'Duration display for weeks, e.g. "1 Week"',
  },
});

const TourPageGlance = createReactClass({
  displayName: 'TourPage-Glance',
  mixins: [PropsMixin],
  propTypes: {
    transportation: PropTypes.string,
    availability: PropTypes.string.isRequired,
    iconClasses: PropTypes.object.isRequired,
    root_unit: PropTypes.object.isRequired,
    availabilityLink: PropTypes.node,
    addons: PropTypes.string,
    has_cancellation: PropTypes.bool,
    has_multiple_locations: PropTypes.bool,
  },

  getInitialState() {
    return { zoomResource: false, bioTruncated: true };
  },

  getDefaultProps() {
    return {
      addons: '',
      availabilityLink: null,
    };
  },

  shouldComponentUpdate() {
    return false;
  },

  _iconClass(name) {
    return `icon ${this.props.iconClasses[name]}`;
  },

  _bioTruncated(truncated) {
    if (truncated !== this.state.bioTruncated) {
      this.setState({
        bioTruncated: truncated,
      });
    }
  },

  _avatarInfo() {
    const { resource_name, resource_picture } = this.props;
    if (resource_picture) {
      return (
        <img alt="avatar" src={resource_picture} width="120" height="120" />
      );
    }
    const splitName = resource_name.split(' ');
    const in1 = splitName[0].charAt(0);
    const in2 = splitName.length > 1 ? splitName[1].charAt(0) : '';
    return (
      <span>
        {in1}
        {in2}
      </span>
    );
  },

  _showResourceModal() {
    const modalMaxHeight =
      window.innerHeight - parseInt(window.innerHeight / 10);
    const { resource_name, resource_bio } = this.props;
    ModalActionCreator.show({
      content: (
        <ResourceModal
          className="resource-modal"
          style={{ maxHeight: modalMaxHeight }}
        >
          <ResourceModalName className="resource-name">
            {resource_name}
          </ResourceModalName>
          <ResourceModalAvatar className="resource-avatar" size={120}>
            {this._avatarInfo()}
          </ResourceModalAvatar>
          <ResourceModalBio className="resource-bio" lines={10000}>
            {resource_bio}
          </ResourceModalBio>
        </ResourceModal>
      ),
      className: 'modal',
      settings: { closable: true },
      showIcon: true,
    });
  },

  _renderExtras() {
    let view = null;

    if (this.props.addons) {
      view = <Addons addons={this.props.addons} />;
    }
    return view;
  },

  _renderLanguages() {
    const { available_languages: availableLanguages } = this.props;

    if (
      !availableLanguages ||
      (availableLanguages.experience_languages == null &&
        availableLanguages.user_languages == null)
    ) {
      return null;
    }

    const {
      experience_languages: experienceLanguages,
      user_languages: userLanguages,
    } = availableLanguages;

    const hasExperienceLanguages =
      experienceLanguages != null && experienceLanguages.trim() !== '';

    const { intl } = this.props;
    const translatedLanguages = userLanguages
      ? userLanguages
          .split(',')
          .map((lang) => {
            const key = lang.trim();
            const message = languageMessages[key];
            return message ? intl.formatMessage(message) : key;
          })
          .join(', ')
      : null;

    return (
      <div className="ui row">
        <div className="center aligned four wide column">
          <i
            className={this._iconClass('languages')}
            aria-hidden="true"
            alt="available languages"
          />
        </div>
        <div className="left aligned eight wide column">
          {hasExperienceLanguages ? (
            experienceLanguages
          ) : (
            <FormattedMessage
              id="OFFERED_IN"
              defaultMessage="Offered in {languages}"
              values={{ languages: translatedLanguages }}
            />
          )}
        </div>
      </div>
    );
  },

  _renderTransportation() {
    if (this.props.transportation == null) {
      return null;
    }
    return (
      <div className="ui row">
        <div className="center aligned four wide column">
          <i className={this._iconClass('transportation')} />
        </div>
        <div className="left aligned eight wide column">
          {this.props.transportation}
        </div>
      </div>
    );
  },

  _renderDuration() {
    const { intl } = this.props;
    // duration_humanized comes from backend as e.g. "2 Hours", "1 Hour", "30 Minutes"
    const [length, ...rest] = this.props.duration_humanized.split(' ');
    const num = parseFloat(length);
    const unitRaw = rest.join(' ').toLowerCase().replace(/s$/, '');
    const unitMessage = durationMessages[unitRaw];

    return (
      <div className="left aligned eight wide column">
        {unitMessage
          ? intl.formatMessage(unitMessage, { num })
          : this.props.duration_humanized}
      </div>
    );
  },

  _renderAvailability() {
    const {
      first_3_dates: datetimes,
      tour_timezone: tourTimezone,
      maxTimes,
      online,
      intl,
    } = this.props;

    let savedTimezoneCode = null;
    let timezone = tourTimezone;
    if (online) {
      timezone = getSavedTimezone() || tourTimezone;
      if (timezone) savedTimezoneCode = timezoneCode(timezone);
    }

    const dates = {};
    datetimes.forEach(({ datetime }) => {
      const convertedDatetime = moment(datetime).tz(timezone);
      const date = convertedDatetime.format('YYYY-MM-DD');

      if (!dates[date]) dates[date] = [];
      dates[date].push(convertedDatetime.toDate());
    });

    const text = Object.keys(dates)
      .slice(0, 3)
      .map((date, idx) => {
        const dateObj = new Date(date + 'T00:00:00');
        const formattedDate = intl.formatDate(dateObj, {
          month: 'short',
          day: 'numeric',
          timeZone: timezone,
        });

        const times = dates[date];
        const formattedTimes = times
          .slice(0, maxTimes)
          .map((timeDate) =>
            intl.formatTime(timeDate, {
              hour: 'numeric',
              minute: '2-digit',
              timeZone: timezone,
            })
          )
          .join(', ');

        const ellipsis = times.length > maxTimes ? '...' : '';

        return (
          <div key={idx}>
            {formattedDate} - {formattedTimes}
            {ellipsis}
            {savedTimezoneCode ? ` (${savedTimezoneCode})` : ''}
          </div>
        );
      });

    return <div>{text}</div>;
  },

  render() {
    const {
      min_people: minPeople,
      max_people: maxPeople,
      root_unit,
      has_multiple_locations,
      intl,
    } = this.props;

    const participantRange =
      minPeople === maxPeople ? maxPeople : `${minPeople} – ${maxPeople}`;
    const nounRaw =
      maxPeople === 1
        ? root_unit.noun_singular_translation
        : root_unit.noun_plural_translation;
    const nounMessage = unitNounMessages[nounRaw];
    const participantNoun = nounMessage
      ? intl.formatMessage(nounMessage)
      : nounRaw;

    return (
      <div className="TourPage-Glance tour-section">
        <h3 className="tour-section-title">
          <FormattedMessage id="AT_A_GLANCE" defaultMessage="At a glance" />
        </h3>
        <div className="ui equal height grid">
          <div className="ui row" data-testid="experience-duration">
            <div className="center aligned four wide column">
              <i
                className={this._iconClass('duration')}
                aria-hidden="true"
                alt="experience duration"
              />
            </div>
            {this._renderDuration()}
          </div>
          <div className="ui row">
            <div className="center aligned four wide column">
              <i
                className={this._iconClass('people')}
                aria-hidden="true"
                alt="number of attendees"
              />
            </div>
            <div
              className="left aligned eight wide column"
              data-testid="participant-range"
            >
              <FormattedMessage
                id="PARTICIPANTS_PER_BOOKING"
                defaultMessage="{range} {unit} per booking"
                values={{ range: participantRange, unit: participantNoun }}
              />
            </div>
          </div>
          {this._renderTransportation()}

          <div className="ui row">
            <div className="center aligned four wide column">
              <i
                className={this._iconClass('availability')}
                aria-hidden="true"
                alt="available date"
              />
            </div>
            <div className="left aligned eight wide column avail">
              {!has_multiple_locations ? this._renderAvailability() : null}
              {this.props.availabilityLink}
            </div>
          </div>

          {this._renderLanguages()}

          {this._renderExtras()}
          <div className="ui row">
            <div className="center aligned four wide column">
              <FormattedMessage
                id="CANCELLATION"
                defaultMessage="Cancellation"
              />
            </div>
            <div className="left aligned eight wide column">
              <CancellationPolicy
                description={this.props.cancellation_policy_description}
                name={this.props.cancellation_policy_name}
                has_cancellation={this.props.has_cancellation}
                zero_priced={this.props.zero_priced}
                is_mobile={Theme.mobile.isMobile}
              />
            </div>
          </div>
        </div>

        {this.props.has_resource && (
          <ResourceDetails>
            <h3 className="tour-section-title">
              <FormattedMessage
                id="ABOUT_YOUR_GUIDE"
                defaultMessage="About your {guide}"
                values={{
                  guide:
                    this.props.resource_name_singular ||
                    intl.formatMessage({
                      defaultMessage: 'Guide',
                    }),
                }}
              />
            </h3>
            <ResourceGrid
              gridTemplateColumns={'100px 1fr'}
              responsiveTemplateColumns={'100%'}
            >
              <ResourceAvatar size={Theme.mobile.isMobile ? 92 : 72}>
                {this._avatarInfo()}
              </ResourceAvatar>
              <ResourceInfo>
                <ResourceName>{this.props.resource_name}</ResourceName>
                <ResourceBio
                  lines={4}
                  onTruncate={this._bioTruncated}
                  className="collapsed"
                  ellipsis={false}
                >
                  {this.props.resource_bio}
                </ResourceBio>
                {this.state.bioTruncated && (
                  <TruncatedGradient>&nbsp;</TruncatedGradient>
                )}
              </ResourceInfo>
            </ResourceGrid>
            {this.state.bioTruncated && (
              <MoreButton
                color={Theme.colors.blue}
                className="brand-border brand-color"
                onClick={() => this._showResourceModal()}
              >
                <FormattedMessage id="READ_MORE" defaultMessage="Read more" />
              </MoreButton>
            )}
          </ResourceDetails>
        )}
      </div>
    );
  },
});

export default injectIntl(TourPageGlance);
